import { contactSearchSignal } from '../../state/contacts.store';
import { Search } from 'lucide-preact';

export function ContactSearch() {
  return (
    <div class="contact-search-container">
      <div class="contact-search-box">
        <Search class="contact-search-icon" />
        <input
          type="text"
          placeholder="Buscar contato..."
          value={contactSearchSignal.value}
          onInput={(e) => contactSearchSignal.value = (e.target as HTMLInputElement).value}
          class="contact-search-input placeholder-slate-500"
        />
      </div>
    </div>
  );
}
